/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MyChartMedicinePatientDetailAliases {
  ACTION_MEDICINE_INACTIVATE = 'action-medicine-inactivate',
  CONTEXTUAL_BAR_MEDICINE_PATIENT_DETAIL = 'contextual-bar-medicine-patient-detail',
  FIELD_CONTINUOUS_MEDICATION = 'field-continuous-medication',
  FIELD_DONT_KNOW_DOSE = 'field-dont-know-dose',
  FIELD_DOSE = 'field-dose',
  FIELD_END_DATE = 'field-end-date',
  FIELD_INTERVAL = 'field-interval',
  FIELD_MEDICINE = 'field-medicine',
  FIELD_NOTES = 'field-notes',
  FIELD_START_DATE = 'field-start-date',
  FIELD_UNIT_MEASUREMENT = 'field-unit-measurement',
  FORM_MEDICINE_PATIENT_DETAIL = 'form-medicine-patient-detail',
  INPUT_PATIENT_MEDICINES_FORMULARY_CONTINUOUS_MEDICATION_MY_CHART_MEDICINE_PATIENT_DETAIL = 'input-patient-medicines-formulary-continuous-medication-my-chart-medicine-patient-detail',
  INPUT_PATIENT_MEDICINES_FORMULARY_DONT_KNOW_DOSE_MY_CHART_MEDICINE_PATIENT_DETAIL = 'input-patient-medicines-formulary-dont-know-dose-my-chart-medicine-patient-detail',
  INPUT_PATIENT_MEDICINES_FORMULARY_DOSE_MY_CHART_MY_CHART_MEDICINE_PATIENT_DETAIL = 'input-patient-medicines-formulary-dose-my-chart-my-chart-medicine-patient-detail',
  INPUT_PATIENT_MEDICINES_FORMULARY_END_DATE_MY_CHART_MEDICINE_PATIENT_DETAIL = 'input-patient-medicines-formulary-end-date-my-chart-medicine-patient-detail',
  INPUT_PATIENT_MEDICINES_FORMULARY_INTERVAL_MY_CHART_MEDICINE_PATIENT_DETAIL = 'input-patient-medicines-formulary-interval-my-chart-medicine-patient-detail',
  INPUT_PATIENT_MEDICINES_FORMULARY_START_DATE_MY_CHART_MEDICINE_PATIENT_DETAIL = 'input-patient-medicines-formulary-start-date-my-chart-medicine-patient-detail',
  INPUT_PATIENT_MEDICINES_FORMULARY_UNIT_MEASUREMENT_MY_CHART_MEDICINE_PATIENT_DETAIL = 'input-patient-medicines-formulary-unit-measurement-my-chart-medicine-patient-detail',
  LAYOUT_MEDICINE_PATIENT_DETAIL = 'layout-medicine-patient-detail',
  PANEL_MEDICINE_PATIENT_DETAIL = 'panel-medicine-patient-detail',
  TEXT_PATIENT_MEDICINES_FORMULARY_MEDICINE_MY_CHART_MEDICINE_PATIENT_DETAIL = 'text-patient-medicines-formulary-medicine-my-chart-medicine-patient-detail',
  TEXT_PATIENT_MEDICINES_FORMULARY_NOTES_MY_CHART_MEDICINE_PATIENT_DETAIL = 'text-patient-medicines-formulary-notes-my-chart-medicine-patient-detail',
}
export { MyChartMedicinePatientDetailAliases };
